/* global angular, moment */
/**
 * Created by lari on 04/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('clientnew', {
      restrict: 'E',
      bindings: {
        onCreate: '&',
        onCancel: '&',
        onSelectRecord: '&',
        mode: '@?'
      },
      templateUrl: 'vcclient/clientnew-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Patient', 'Client', 'ClientHelper', '$state',
        function ($log, $http, Patient, Client, ClientHelper, $state) {
          let vm = this;
          let url;
          vm.orgSearch = orgSearch;
          vm.nameSearch = nameSearch;
          vm.setLastname = setLastname;
          vm.setOrgname = setOrgname;
          vm.createPatient = createPatient;
          vm.gotoRecord = gotoRecord;


          // wrapper for parent function calls
          /*          vm.oncreate = function () {
           return vm.onCreate();
           };*/

          vm.cancel = function () {
            return vm.onCancel();
          };

          vm.showRecord = function (id) {
            return vm.onSelectRecord({clientid: id});
          };


          vm.$onInit = function () {
            vm.newclient = {};
            vm.newclient.primarycontact = {};
            vm.newclient.svdata = {};
            vm.newclient.companydata = {};
            if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
              vm.mode = 'client';
              url = '/routes/clients/searchahead';
              vm.kunde = 'Kunde';
              vm.kunden = 'Kunden';
            } else {
              url = '/routes/clients/searchahead';
              vm.kunde = 'Patient';
              vm.kunden = 'Patienten';
            }
            $log.debug('debug: clientnew $onInit() url: ', url);
          }; // $onInit()

          // tagahead organisation search
          function orgSearch(val) {
            return ClientHelper.searchahead({
              query: val,
              fields: ['companydata.name', 'primarycontact.lastname']
            }, vm.mode).$asPromise().then(function (response) {
              return response.map(function (client) {
                ClientHelper.fname(client, vm.mode);
                delete vm.error;
                return client;
              });
            });
          }

          // tagahead name search
          function nameSearch(val) {
            return ClientHelper.searchahead({
              query: val,
              fields: ['primarycontact.lastname', 'primarycontact.firstname']
            }, vm.mode).$asPromise().then(function (response) {
              response.map(function (client) {
                ClientHelper.fname(client, vm.mode);
                delete vm.error;
                return client;
              });
              vm.clientResults = response;
              return response;

            });
          }


          function catchClick($event) {
            $log.debug('event caught: ', $event);
          }

          function gotoRecord(client) {
            $log.debug('debug - gotoRecord going to state: ', client._id);
            // $state.go('playground.vcutilsdoctor.allcomponents', {
            vm.onCreate({client: client, mode: vm.mode});
            // TODO: target state needs to be valid for transisiton to occur!
    /*        $state.go('clientrecord.basicdata', {
              client: client,
              clientid: client._id,
              patientid: client._id,
              mode: vm.mode
            });*/
          }

          function setLastname($item, $model, $label, $event) {
            if ($event.toElement.getAttribute('class') === 'btn btn-info gotorec') {
              gotoRecord($item);
            }
            else {
              if (!angular.isObject(vm.newclient)) {
                vm.newclient = {};
              }
              vm.newclient.primarycontact.lastname = $model.primarycontact.lastname;
            }
          }

          function setOrgname($item, $model, $label, $event) {
            if ($event.toElement.getAttribute('class') === 'btn btn-info gotorec') {
              gotoRecord($item);
            }
            else {
              if (!angular.isObject(vm.newclient)) {
                vm.newclient = {};
              }
              vm.newclient.companydata.name = $model.companydata.lastname;
            }
          }


          function createPatient() {
            // this is totally ugly, but it seems to work
            $log.debug('vm.newclient create: ', vm.newclient);

            if (vm.mode === 'patient') {
              Patient.$create(vm.newclient).$then(function (client) {
                console.log('patid: ', client._id);
                vm.onCreate({client: client, mode: vm.mode});
                // $state.go('patientrecord.basicdata', {patientid: vcclient._id});
              });
            }
            else {
              Client.$create(vm.newclient).$then(function (client) {
                console.log('clientid: ', client._id);
                vm.onCreate({client: client, mode: vm.mode});
                // $state.go('patientrecord.basicdata', {clientid: vcclient._id});
              });
            }


          }


          /*          function cancel() {
           vm.dialog.close();
           if ($state.previousState && $state.previousParams) {
           $state.go($state.previousState.name, $state.previousParams);
           }

           if ($state.previousState && !$state.previousParams) {
           $state.go($state.previousState.name);
           }


           }*/


          /*          function save() {
           if (!angular.equals(vm.vcclient, vm.lastclient)) {
           vm.lastclient = angular.copy(vm.vcclient);
           vm.parentsave();
           }
           }*/


        }] // controller
    }); // component

// klammerfriedhof
}());